<template>
  <div class="tl">
    <Menu />
    <div class="cont">
      <section class="bnr">
        <div class="inner">
          <p class="title title1">随时随地</p>
          <p class="title">安全稳定的远程办公</p>
          <p class="desc">
            流畅 · 稳定 · 安全 · 合规<br />帮助您打造时代前列的灵活办公体系
          </p>
          <div class="btns">
            <a
              id="ep_tw_bnr_trial_btn1"
              class="btn epBtn1 btn1"
              :href="to_register"
              >免费试用</a
            >
            <a
              id="ep_tw_bnr_ctact_btn1"
              class="btn epBtn2 btn2"
              href="https://enterprise.todesk.com/contact"
              >联系我们</a
            >
          </div>
        </div>
        <div class="bkg">
          <img
            class="bnr_img"
            src="https://todeskcdnspeed.todesk.com/mobile/telework/bnr@2x.png"
            alt="远程办公"
          />
        </div>
      </section>
      <section class="partner partner1">
        <img
          v-for="(item, index) in logo_list1"
          :key="index"
          :src="item"
          alt=""
          class="logo_item"
        />
      </section>
      <section class="partner partner2">
        <img
          v-for="(item, index) in logo_list2"
          :key="index"
          :src="item"
          alt=""
          class="logo_item"
        />
      </section>
      <section class="pdn prospect">
        <div class="bkgleft"></div>
        <div class="bkgright"></div>
        <div class="inner">
          <h2 class="title">远程办公如何塑造<br />下一个十年的成功企业</h2>
          <div class="bx">
            <div
              class="bx_item"
              v-for="(item, index) in prospect_list"
              :key="index"
            >
              <img class="item_img" :src="item.icon" alt="" />
              <p class="item_title">
                {{ item.title[0] }}<br />{{ item.title[1] }}
              </p>
            </div>
          </div>
        </div>
      </section>
      <section class="pdn feature feature1">
        <div class="datainfo">
          <h3 class="title">
            <span class="t1">用ToDesk，开启办公变革</span>
          </h3>
          <div class="desc_item">
            <img
              src="https://todeskcdnspeed.todesk.com/mobile/telework/icon_ok@2x.png"
              alt=""
              class="desc_icon"
            /><span class="desc_text">0.04秒超低延时，操作自然顺手</span>
          </div>
          <div class="desc_item">
            <img
              src="https://todeskcdnspeed.todesk.com/mobile/telework/icon_ok@2x.png"
              alt=""
              class="desc_icon"
            /><span class="desc_text">隐私屏保护，信息不泄露</span>
          </div>
          <div class="desc_item">
            <img
              src="https://todeskcdnspeed.todesk.com/mobile/telework/icon_ok@2x.png"
              alt=""
              class="desc_icon"
            /><span class="desc_text">账户-设备1对1绑定，办公电脑更放心</span>
          </div>
          <div class="desc_item">
            <img
              src="https://todeskcdnspeed.todesk.com/mobile/telework/icon_ok@2x.png"
              alt=""
              class="desc_icon"
            /><span class="desc_text">批量部署+AD域，管理便捷规范</span>
          </div>
        </div>
        <div class="imginfo">
          <img src="https://todeskcdnspeed.todesk.com/mobile/telework/feature1@2x.png" alt="" />
        </div>
        <a class="toenjoy" :href="to_register">
          <p>开启远程办公新体验</p>
          <img src="https://todeskcdnspeed.todesk.com/mobile/telework/angle_right@2x.png" alt="" />
        </a>
      </section>
      <section class="pdn feature feature2">
        <div class="datainfo">
          <h3 class="title">
            <span class="t1">企业版优享传输线路<br />力保</span
            ><span class="t2">流畅稳定</span>
          </h3>
        </div>
        <div class="imginfo">
          <video
            preload="auto"
            playsinline
            playsinlinex5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-playsinline="true"
            x-webkit-airplay="allow"
            x5-video-orientation="landscape|portrait"
            style="object-fit: fill"
            webkit-playsinline="true"
            x5-video-player-type="h5-page"
            class="brvideo"
            autoplay
            muted
            loop
          >
            <source
              src="https://todeskcdnspeed.todesk.com/202206071810275e0d8cc3ced2fc.mp4"
              type="video/mp4"
            />
            您的浏览器不支持Video标签。
          </video>
        </div>
        <a class="epBtn2 trail" :href="to_register">开始试用</a>
      </section>
      <section class="pdn feature feature3">
        <div class="datainfo">
          <h3 class="title">
            <span class="t1">批量部署及AD域</span><br />
            <span class="t2">轻松</span><span class="t1">首次部署</span>
          </h3>
        </div>
        <div class="imginfo">
          <video
            preload="auto"
            playsinline
            playsinlinex5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-playsinline="true"
            x-webkit-airplay="allow"
            x5-video-orientation="landscape|portrait"
            style="object-fit: fill"
            webkit-playsinline="true"
            x5-video-player-type="h5-page"
            class="brvideo"
            autoplay
            muted
            loop
          >
            <source
              src="https://todeskcdnspeed.todesk.com/202206071705105e0d7e2c27fe94.mp4"
              type="video/mp4"
            />
            您的浏览器不支持Video标签。
          </video>
        </div>
        <a class="epBtn2 trail" :href="to_register">开始试用</a>
      </section>
      <section class="pdn feature feature4">
        <div class="datainfo">
          <h3 class="title">
            <span class="t1">隐私屏+键鼠锁</span><br />
            <span class="t1">工作信息</span><span class="t2">不泄露</span>
          </h3>
        </div>
        <div class="imginfo">
          <video
            preload="auto"
            playsinline
            playsinlinex5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-playsinline="true"
            x-webkit-airplay="allow"
            x5-video-orientation="landscape|portrait"
            style="object-fit: fill"
            webkit-playsinline="true"
            x5-video-player-type="h5-page"
            class="brvideo"
            autoplay
            muted
            loop
          >
            <source
              src="https://todeskcdnspeed.todesk.com/202206071811005e0d8ce2f830d0.mp4"
              type="video/mp4"
            />
            您的浏览器不支持Video标签。
          </video>
        </div>
        <a class="epBtn2 trail" :href="to_register">开始试用</a>
      </section>
      <section class="efficacy">
        <h3 class="title">贴心安全设置，安全尽在掌控</h3>
        <div class="tabs">
          <div
            @click="changeEfficacy(index)"
            class="tab_item efficacy_item"
            v-for="(item, index) in efficacy_list"
            :key="index"
            :class="efficacy_index == index ? 'active' : ''"
          >
            <img :src="item.icon" alt="" class="tab_icon" />
            <p class="tab_name">{{ item.title }}</p>
          </div>
        </div>
        <div class="efficacy_line" id="efficacy_line">
          <p class="efficacy_move" id="efficacy_move"></p>
        </div>
        <div class="pic">
          <img :src="efficacy_list[efficacy_index].pic" alt="" />
        </div>
      </section>
      <section class="pnd contrast">
        <h3 class="title">稳定流畅没有捷径，只有硬实力</h3>
        <div class="bx">
          <div class="item">
            <h5 class="item_title"><span class="t1">ToDesk</span></h5>
            <div class="item_desc">
              <p>
                <span class="t1">全球</span><span class="t2"> 200+ </span
                ><span class="t1">节点机房</span>
              </p>
              <p>
                <span class="t1">更多路线选择与备份保障</span
                ><span class="t2"></span>
              </p>
            </div>
            <img
              src="https://todeskcdnspeed.todesk.com/2023111715455760a5453a3d100c.png"
              alt=""
              class="item_pic"
            />
          </div>
          <p class="line"></p>
          <div class="item">
            <h5 class="item_title"><span class="t2">传统厂商</span></h5>
            <div class="item_desc">
              <p>
                <span class="t1">仅</span><span class="t2"> 4个 </span
                ><span class="t1">转发机房</span>
              </p>
            </div>
            <img
              src="https://todeskcdnspeed.todesk.com/2023111616394260a40f612c6610.png"
              alt=""
              class="item_pic"
            />
          </div>
        </div>
      </section>
      <section class="costs">
        <h3 class="title">为不同场景选择最优惠收费方式<br />无隐形收费项</h3>
        <div class="bx">
          <div class="item item1">
            <img src="https://todeskcdnspeed.todesk.com/mobile/telework/good@2x.png" alt="" class="item_icon" />
            <img
              src="https://todeskcdnspeed.todesk.com/mobile/telework/combo1@2x.png"
              alt=""
              class="item_bkg"
            />
            <div class="item_bx">
              <h5 class="item_title">企业版-标准版</h5>
              <p class="item_subtitle">
                适用于远程办公、虚拟机、多人控制一台电脑等
              </p>
              <div class="itemfts">
                <div
                  class="itemfts_item"
                  v-for="(item, index) in standard_list"
                  :key="index"
                >
                  <img src="https://todeskcdnspeed.todesk.com/mobile/telework/icon_right@2x.png" alt="" />
                  <span>{{ item }}</span>
                </div>
              </div>
              <router-link class="togo" to="/pricing_enterprise.html">
                <p>更多安全功能和权益</p>
                <img src="https://todeskcdnspeed.todesk.com/mobile/telework/to_right@2x.png" alt="" />
              </router-link>
              <a :href="to_register" class="epBtn2 item_btn">免费试用</a>
            </div>
          </div>
          <div class="item item2">
            <img
              src="https://todeskcdnspeed.todesk.com/mobile/telework/combo2@2x.png"
              alt=""
              class="item_bkg"
            />
            <div class="item_bx">
              <h5 class="item_title">私有化部署</h5>
              <p class="item_subtitle">灵活定制本地部署方案大型团队定制方案</p>
              <div class="itemfts">
                <div
                  class="itemfts_item"
                  v-for="(item, index) in private_list"
                  :key="index"
                >
                  <span class="itemfts_item_dot"> · </span>
                  <span>{{ item }}</span>
                </div>
              </div>
            </div>
            <a :href="contact_way2" class="epBtn2 item_btn">咨询客户经理</a>
          </div>
        </div>
      </section>
      <Certificate :hidebkg="true" />
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import Certificate from "@/components/Common/Certificate.vue";
import { mapState } from "vuex";
import { videoReady } from "../../utils/util";
export default {
  components: {
    Menu,
    Footer,
    Certificate,
  },
  data() {
    return {
      prospect_list: [
        {
          title: ["先进", "信息管理"],
          icon: "https://todeskcdnspeed.todesk.com/mobile/telework/prospect1@2x.png",
          desc: [
            "100%数据不落地，企业数据集中存储，公司降",
            "低数据泄露风险，员工免去文件同步烦恼",
          ],
        },
        {
          title: ["优化", "办公空间"],
          icon: "https://todeskcdnspeed.todesk.com/mobile/telework/prospect2@2x.png",
          desc: [
            "更低租金，更高价值。腾出低效的固定工位，节",
            "省物业租金，改善办公环境和企业形象",
          ],
        },
        {
          title: ["聚焦", "人才队伍"],
          icon: "https://todeskcdnspeed.todesk.com/mobile/telework/prospect3@2x.png",
          desc: [
            "更强吸引，更少流失。提升组织灵活度，对内降",
            "低员工流失，对外强化雇主品牌和人才吸引力",
          ],
        },
      ],
      efficacy_timer: null,
      efficacy_index: 0,
      efficacy_list: [
        {
          title: "连接日志",
          icon: "https://todeskcdnspeed.todesk.com/mobile/telework/efficacy_icon0@2x.png",
          pic: "https://todeskcdnspeed.todesk.com/mobile/telework/efficacy_pic0@2x.png",
        },
        {
          title: "加密录屏",
          icon: "https://todeskcdnspeed.todesk.com/mobile/telework/efficacy_icon1@2x.png",
          pic: "https://todeskcdnspeed.todesk.com/mobile/telework/efficacy_pic1@2x.png",
        },
        {
          title: "可控文件传输",
          icon: "https://todeskcdnspeed.todesk.com/mobile/telework/efficacy_icon2@2x.png",
          pic: "https://todeskcdnspeed.todesk.com/mobile/telework/efficacy_pic2@2x.png",
        },
        {
          title: "账户-设备绑定",
          icon: "https://todeskcdnspeed.todesk.com/mobile/telework/efficacy_icon3@2x.png",
          pic: "https://todeskcdnspeed.todesk.com/mobile/telework/efficacy_pic3@2x.png",
        },
      ],
      standard_list: [
        "用户数 1个",
        "设备数 5个",
        "通道数 1个",
        "禁用设备码",
        "实时监控报警",
        "加密录屏",
        "永久保存操作日志",
      ],
      private_list: [
        "按照公司规模和业务需要，灵活搭配账户类型和功能套餐",
        "多种线路方案可选，私有化部署也可享企业级SD-WAN网络服务",
        "按需定制更多安全功能，满足各行业合规要求",
        "胜任大型组织、多分支、多厂区场景，支持10万级设备和人员的结构化管理",
      ],
      logo_list1: [
        require("@/assets/partner/Walmart_logo@2x.png"),
        require("@/assets/partner/bohai_logo@2x.png"),
        require("@/assets/partner/ruijie.png"),
      ],
      logo_list2: [
        require("@/assets/partner/yuncong_logo@2x.png"),
        require("@/assets/partner/zh_logo@2x.png"),
      ],
    };
  },
  mounted() {
    this.setEfficacyChange();
    videoReady();
  },
  methods: {
    changeEfficacy(index) {
      if (index == this.efficacy_index) {
        return;
      } else {
        clearInterval(this.efficacy_timer);
        this.efficacy_timer = null;
        this.startEfficacyChange(index);
        this.setEfficacyChange();
      }
    },
    setEfficacyChange() {
      this.efficacy_timer = setInterval(() => {
        let next_index = 0;
        if (this.efficacy_index != 3) {
          next_index = this.efficacy_index;
          next_index++;
        }
        this.startEfficacyChange(next_index);
      }, 5000);
    },
    startEfficacyChange(next_index) {
      this.efficacy_index = next_index;
      const w = document.getElementById("efficacy_line").offsetWidth;
      document.getElementById("efficacy_move").style.left =
        (w / 4) * next_index + "px";
      document.getElementById("efficacy_move").style.transition = "left 0.5s";
    },
  },
  computed: {
    ...mapState(["to_register", "contact_way", "contact_way2"]),
  },
  beforeDestroy() {
    clearInterval(this.efficacy_timer);
  },
};
</script>
<style lang="less" scoped>
.cont {
  .bnr {
    position: relative;
    .inner {
      width: 100%;
      height: 468px;
      text-align: center;
      .title1 {
        padding-top: 184px;
      }
      .title {
        font-size: 34px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222429;
        line-height: 48px;
      }
      .desc {
        margin: auto;
        margin-top: 14px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #585f69;
        line-height: 22px;
        width: 306px;
      }
      .btns {
        margin-top: 32px;
        display: flex;
        justify-content: center;
        .btn {
          margin-left: 7px;
          margin-right: 7px;
        }
        .btn1 {
          height: 54px;
          width: 156px;
          line-height: 54px;
        }
        .btn2 {
          height: 54px;
          width: 156px;
          line-height: 52px;
        }
      }
    }
    .bkg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
      .bnr_img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .partner {
    background: #fff;
    padding-top: 20px;
    padding-bottom: 20px;
    display: flex;
    justify-content: space-around;
    width: 100%;
    margin: auto;
    flex-flow: row wrap;
    .logo_item {
      height: 20px;
      width: auto;
    }
  }
  .partner1 {
    padding-bottom: 10px;
  }
  .partner2 {
    padding-top: 10px;
  }
  .prospect {
    text-align: center;
    position: relative;
    .bkgleft {
      position: absolute;
      left: 0;
      top: 0;
      width: 101px;
      height: 226px;
      background: rgba(71, 153, 255, 0.06);
      filter: blur(50px);
    }
    .bkgright {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 132px;
      height: 170px;
      background: rgba(71, 153, 255, 0.06);
      filter: blur(50px);
    }
    .inner {
      .title {
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222429;
        line-height: 33px;
      }
      .bx {
        padding-left: 40px;
        padding-right: 40px;
        display: flex;
        justify-content: space-between;
        margin-top: 24px;
        .bx_item {
          width: 64px;
        }
        .item_img {
          width: 60px;
          height: 60px;
        }
        .item_title {
          margin-top: 6px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #222429;
          line-height: 22px;
          margin-left: -15px;
          margin-right: -15px;
        }
      }
    }
  }
  .feature {
    padding-left: 24px;
    padding-right: 24px;
    box-sizing: border-box;
    background: #fff;
    .title {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
      text-align: center;
      margin-bottom: 27px;
      .t2 {
        color: #0065dd;
      }
    }
    .desc_item {
      margin-left: 16px;
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      .desc_icon {
        width: 20px;
        height: 20px;
      }
      .desc_text {
        margin-left: 12px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222429;
      }
    }
    .imginfo {
      margin-top: 24px;
      .brvideo,
      img {
        width: 100%;
        height: auto;
      }
    }
    .toenjoy {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 32px;
      p {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0065dd;
      }
      img {
        width: 20px;
        margin-left: 6px;
      }
    }
  }
  .feature4,
  .feature2 {
    background: #f4f5f6;
  }
  .efficacy {
    padding-top: 32px;
    padding-bottom: 24px;
    background: #fff;
    .title {
      text-align: center;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
    }
    .tabs {
      display: flex;
      margin-top: 22px;
      .tab_item {
        flex: 1;
        text-align: center;
      }
      img {
        width: 40px;
        height: 40px;
      }
      p {
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 500;
        color: #222429;
        margin-top: 3px;
      }
      .tab_item.active {
        p {
          color: #216ed8;
        }
      }
    }
    .efficacy_line {
      width: 100%;
      height: 2px;
      background: #f5f6fa;
      margin-top: 11px;
      position: relative;
      .efficacy_move {
        position: absolute;
        left: 0;
        bottom: 1px;
        height: 3px;
        background: #0065dd;
        width: 25%;
      }
    }
    .pic {
      padding-top: 15px;
      img {
        width: 100%;
      }
    }
  }
  .contrast {
    background: #f9f9f9;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 32px;
    .title {
      text-align: center;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
      margin-left: -24px;
      margin-right: -24px;
    }
    .bx {
      margin-top: 24px;
      display: flex;
      justify-content: center;
    }
    .item {
      text-align: center;
      .item_title {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222429;
        .t1 {
          color: #0065dd;
        }
      }
      .item_desc {
        margin-top: 8px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222429;
        height: 45px;
        .t2 {
          font-size: 14px;
          font-weight: 600;
        }
      }
      .item_pic {
        margin-top: 15px;
        width: 144px;
        height: auto;
      }
    }
    .line {
      margin-left: 20px;
      margin-right: 20px;
      width: 0;
      height: 170px;
      border-left: 1px dashed #cccfd4;
      margin-top: 30px;
    }
  }
  .costs {
    padding: 32px 24px;
    background: linear-gradient(180deg, #e7edfa 0%, #f6f7f8 100%);
    .title {
      text-align: center;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
      margin-left: -20px;
      margin-right: -20px;
    }
    .item {
      position: relative;
      padding: 20px 30px;
      padding-bottom: 30px;
      background: #fff;
      border-radius: 8px;
      z-index: 1;
      .item_title {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222429;
      }
      .item_subtitle {
        margin-top: 2px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222429;
      }
      .item_bkg {
        position: absolute;
        right: 0;
        top: 43px;
        width: 126px;
        z-index: -1;
      }
    }
    .item1 {
      margin-top: 24px;

      .item_icon {
        position: absolute;
        right: 23px;
        top: 9px;
        width: 30px;
        z-index: -1;
      }

      .item_btn {
        margin-top: 45px;
        width: 100%;
        line-height: 48px;
        display: block;
        font-size: 18px;
      }
      .itemfts {
        margin-top: 20px;
        display: flex;
        flex-flow: row wrap;
        .itemfts_item {
          display: flex;
          align-items: center;
          width: 50%;
          margin-bottom: 8px;
          img {
            width: 16px;
          }
          span {
            margin-left: 6px;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #222429;
          }
        }
      }
      .togo {
        display: flex;
        margin-top: 10px;
        align-items: center;
        p {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #0065dd;
        }
        img {
          width: 14px;
          height: 14px;
          margin-left: 2px;
          margin-top: 2px;
        }
      }
    }
    .item2 {
      margin-top: 16px;
      background: linear-gradient(357deg, #3eb2ff 0%, #136ff0 100%);
      box-shadow: 0px 1px 6px 0px rgba(88, 95, 105, 0.14);
      .item_title {
        color: #fff;
      }
      .item_subtitle {
        color: rgba(255, 255, 255, 0.75);
      }
      .itemfts {
        width: 200px;
        margin-top: 20px;
        .itemfts_item {
          font-size: 13px;
          margin-bottom: 8px;
          text-shadow: 0px 0px 1px rgba(0, 50, 122, 0.1);
          color: rgba(255, 255, 255, 0.85);
        }
      }
      .item_btn {
        margin-top: 18px;
        width: 100%;
        line-height: 48px;
        background: #ffffff;
        border-radius: 4px;
        display: block;
        border: none;
        font-size: 18px;
      }
    }
  }
}

.trail {
  display: block;
  margin: auto;
  margin-top: 40px;
  width: 128px;
  line-height: 42px;
}
</style>
